import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { BaseAppAuthGuardService } from './core/services/base-app-auth-guard.service';
import { FreeTrialAuthService } from './core/services/free-trial-auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  // {
  //   path: 'signup',
  //   loadChildren: () => import('./subscribe-now/subscribe-now.module').then( m => m.SubscribeNowPageModule)
  // },
  {
    path: 'start-free-trial',
    loadChildren: () => import('./start-free-trial/start-free-trial.module').then( m => m.StartFreeTrialPageModule),
    canActivate: [FreeTrialAuthService],
  },
  {
    path: 'verify',
    loadChildren: () => import('./verify-code/verify-code.module').then( m => m.VerifyCodePageModule)
  },
  {
    path: 'set-password',
    loadChildren: () => import('./set-password/set-password.module').then( m => m.SetPasswordPageModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./reset-password/reset-password.module').then( m => m.ResetPasswordPageModule)
  },
  {
    path: 'emailer-page',
    loadChildren: () => import('./emailer-page/emailer-page.module').then( m => m.EmailerPagePageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(mod => mod.LoginPageModule),
    title: "eZintegrations | Login"
  },
  {
    path: 'baseapp',
    loadChildren: () => import('./base-app/base-app.module').then(mod => mod.BaseAppPageModule),
    canActivate: [BaseAppAuthGuardService]
  },
  {
    path: 'change-password',
    loadChildren: () => import('./change-password/change-password.module').then( m => m.ChangePasswordPageModule)
  },
  {
    path: 'vendor',
    loadChildren: () => import('./vendor/vendor.module').then(mod => mod.VendorPageModule)
  },
  {
    path: '**', redirectTo: 'login'
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
